function directive() {
    return {
        link: function ($scope, element, attrs) {
            var icon = attrs.name;
            var elm = d3.select(element[0])
                .append('svg')
                .attr('x',0)
                .attr('y',0)
                .attr('width','0')
                .attr('height','0');
            var em = elm.append('g');
            // switch between text
            switch (icon) {
                case 'fa-active-defense':
                    elm
                        .attr('width','14')
                        .attr('height','16');
                    em
                        .append('path')
                        .attr('transform', 'translate(0,0) scale(0.75)')
                        .style('fill', '#eeeeee')
                        .attr("d", "M9,0L0,4v6c0,5.4,3.6,10,8.5,11.5C13.4,20,17,15.4,17,10V4L9,0z M3.8,10h4L3.2,5.1h5.6l4,5.9h-3l4,6L3.8,10z");
                    return;
                case 'fa-network-ips':
                    elm
                        .attr('width','14')
                        .attr('height','16');
                    em
                        .append('path')
                        .attr('transform', 'translate(0,2) scale(0.75)')
                        .style('fill', '#eeeeee')
                        .attr("d", "M6,5H0V0h6V5z M15,0H8v5h7V0z M19,0h-2v5h2V0z M2,7H0v5h2V7z M11,7H4v5h7V7z M19,7h-6v5h6V7z M6,14H0v5h6V14z M15,14H8v5h7V14z M19,14h-2v5h2V14z");
                    return;
                case 'fa-target':
                    elm
                        .attr('width','11')
                        .attr('height','13');
                    em
                        .append('path')
                        .attr('transform', 'translate(0,2) scale(0.55)')
                        .style('fill', '#eeeeee')
                        .attr("d", "M10,0C4.5,0,0,4.5,0,10c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C20,4.5,15.5,0,10,0z M10,18c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8C18,14.4,14.4,18,10,18z M10,4c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S13.3,4,10,4z M10,14c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S12.2,14,10,14z M12,10c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S12,8.9,12,10z");
                    return;
                case 'fa-blacklist':
                    elm
                        .attr('width','16')
                        .attr('height','13');
                    em
                        .append('path')
                        .attr('transform', 'translate(0,2) scale(0.7)')
                        .style('fill', 'none')
                        .style('stroke', '#fff')
                        .style('stroke-width', '1.5')
                        .attr("d", "M11,0C6.1,0,1.9,2.9,0,7c1.9,4.1,6.1,7,11,7c4.9,0,9.1-2.9,11-7C20.1,2.9,15.9,0,11,0z M11,12c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5S13.8,12,11,12z M14,7.1c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3C12.7,4.1,14,5.5,14,7.1z");
                    return;
                case 'fa-whitelist':
                    elm
                        .attr('width','15')
                        .attr('height','13');
                    em
                        .append('path')
                        .attr('transform', 'translate(0,2) scale(0.7)')
                        .style('fill', '#eeeeee')
                        .attr("d", "M11,0C6.1,0,1.9,2.9,0,7c1.9,4.1,6.1,7,11,7c4.9,0,9.1-2.9,11-7C20.1,2.9,15.9,0,11,0z M11,12c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5S13.8,12,11,12z M14,7.1c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3C12.7,4.1,14,5.5,14,7.1z");
                   return;
                case 'fa-wifi':
                    elm
                        .attr('width','15')
                        .attr('height','13');
                    em
                        .append('path')
                        .attr('transform', 'translate(0) scale(0.025)')
                        .style('fill', '#fff')
                        .attr("d", "M384 416c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm136.659-124.443c6.465-6.465 6.245-17.065-.564-23.167-113.793-101.985-286.526-101.869-400.19 0-6.809 6.102-7.029 16.702-.564 23.167l34.006 34.006c5.927 5.927 15.464 6.32 21.769.796 82.88-72.609 207.074-72.447 289.768 0 6.305 5.524 15.842 5.132 21.769-.796l34.006-34.006zm112.11-113.718c6.385-6.385 6.254-16.816-.35-22.973-175.768-163.86-449.134-163.8-624.837 0-6.604 6.157-6.735 16.589-.35 22.973l33.966 33.966c6.095 6.095 15.891 6.231 22.224.383 144.763-133.668 368.356-133.702 513.156 0 6.333 5.848 16.129 5.712 22.224-.383l33.967-33.966z");
                    return;
                case 'icon-broadcast':
                    elm
                        .attr('width','15')
                        .attr('height','15');
                    em
                        .append('path')
                        .attr('transform', 'translate(-1,0) scale(0.035)')
                        .style('fill', '#eee')
                        .attr("d", "M221.309,465.929V244.183c-9.616-6.411-16.026-17.483-16.026-30.013c0-19.814,16.026-35.841,35.841-35.841   s35.841,16.026,35.841,35.841c0,14.569-8.742,27.099-20.98,32.635v219.124c0,9.616-7.867,17.483-17.483,17.483   S221.309,475.545,221.309,465.929z M328.248,284.977c2.914,1.748,5.828,2.622,9.033,2.622c5.828,0,11.656-2.914,14.861-8.45   c13.112-21.563,19.523-46.331,18.357-71.681c-2.914-70.516-62.648-125.588-133.456-122.966   c-33.801,1.457-65.271,16.026-88.582,41.377c-23.311,25.059-35.258,57.986-33.801,92.079c0.874,20.106,6.119,39.337,15.735,56.821   c4.662,8.45,15.444,11.656,23.894,6.702c8.45-4.662,11.364-15.444,6.702-23.894c-6.993-12.821-10.781-26.516-11.656-41.377   c-0.874-24.768,7.867-48.662,24.477-67.019s40.212-28.556,64.979-29.722c51.284-2.04,94.992,37.88,97.032,89.456   c0.874,18.357-3.788,36.423-13.404,52.158C317.467,269.242,320.09,280.024,328.248,284.977z M379.533,352.288   c7.285,6.119,18.357,5.245,24.768-2.04c32.344-38.463,50.119-87.125,50.119-137.535C454.419,95.284,359.136,0,241.706,0   S28.993,95.284,28.993,212.713c0,53.324,19.814,104.025,55.655,143.363c3.497,3.788,8.159,5.828,12.821,5.828   c4.079,0,8.45-1.457,11.656-4.662c6.993-6.411,7.576-17.483,1.166-24.768c-29.722-32.635-46.331-75.178-46.331-119.76   c0-97.906,79.84-177.747,177.747-177.747s177.747,79.84,177.747,177.747c0,41.96-14.861,82.754-41.96,114.807   C371.082,334.805,371.957,345.877,379.533,352.288z");
                    return;
                default:
                    return;
            }
            $scope.$on('$destroy', function () {
                element.remove();
            });
        }
    };
}

directive.$inject = [];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/sidebaricon/sidebaricon.js
 **/